import React from 'react';
import { Card, Space, Typography } from 'antd';

const { Text } = Typography;

const NetworkInformation = React.memo(({ network }) => {
    if (!network?.interfaces || Object.keys(network.interfaces).length === 0) {
        return null;
    }

    return (
        <Card title="Network Adapters" size="small" type="inner">
            <Space orientation="vertical">
                {Object.values(network.interfaces).map((iface, index) => (
                    <div key={index}>
                        <Text strong>{iface.name}</Text>
                        <div className={'margin-left-16'}>
                            {iface.ip_addr && (
                                <div>
                                    IP: <Text copyable>{iface.ip_addr}</Text>
                                </div>
                            )}
                            {iface.mac_addr && (
                                <div>
                                    MAC: <Text type="secondary">{iface.mac_addr}</Text>
                                </div>
                            )}
                            {iface.netmask && (
                                <div>
                                    Netmask: <Text type="secondary">{iface.netmask}</Text>
                                </div>
                            )}
                            {iface.type && (
                                <div>
                                    Type: <Text type="secondary">{iface.type}</Text>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </Space>
        </Card>
    );
});

export default NetworkInformation;
